"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const TGOptionLazyModalActions = (props) => {
    const { multiSelect, state, isNothingSelected, totalCount, handleClearAll, selectAllAssets, translateFunction = text => text } = props, moreProps = __rest(props, ["multiSelect", "state", "isNothingSelected", "totalCount", "handleClearAll", "selectAllAssets", "translateFunction"]);
    const classes = useStyles();
    const numberOfElements = (0, react_1.useMemo)(() => {
        if (isNothingSelected) {
            return totalCount;
        }
        return state.length;
    }, [isNothingSelected, totalCount, state]);
    const button = (0, react_1.useMemo)(() => {
        if (multiSelect) {
            if (isNothingSelected) {
                return (react_1.default.createElement(core_1.Button, { className: classes.btn, onClick: selectAllAssets, variant: "text" }, translateFunction('Select All')));
            }
            else {
                return (react_1.default.createElement(core_1.Button, { className: classes.btn, onClick: handleClearAll, variant: "text" }, translateFunction('Deselect All')));
            }
        }
        else {
            return (react_1.default.createElement(core_1.Button, { className: classes.btn, onClick: handleClearAll, variant: "text" }, translateFunction('Clear Selection')));
        }
    }, [multiSelect, isNothingSelected, handleClearAll, selectAllAssets]);
    // Brackets are inside spans in order to center them vertically with the text (Roboto by default does not do that)
    if (multiSelect) {
        return (react_1.default.createElement("div", { className: classes.actionsContainer },
            button,
            react_1.default.createElement(core_1.Typography, { className: classes.numberOfElements },
                react_1.default.createElement("span", null, "("),
                numberOfElements,
                react_1.default.createElement("span", null, ")"))));
    }
    return button;
};
const useStyles = (0, core_1.makeStyles)(theme => ({
    actionsContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.palette.primary.main,
    },
    numberOfElements: {
        fontSize: 16,
        fontWeight: 500,
        fontStyle: 'normal',
        lineHeight: 'normal',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.palette.primary.main,
        marginLeft: 3,
        '& span': {
            height: 21.5,
        },
    },
    btn: {
        padding: 0,
        color: theme.palette.primary.main,
        textTransform: 'none',
        fontSize: 16,
        fontWeight: 500,
        fontStyle: 'normal',
        lineHeight: 'normal',
    },
}));
exports.default = TGOptionLazyModalActions;
//# sourceMappingURL=TGOptionLazyModalActionsWeb.js.map